import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PixelMask } from './PixelMask';
import { EmberCanvas } from './EmberCanvas';
import { HeroHud } from './HeroHud';
import { HeroRuler } from './HeroRuler';
import { PlusButton } from '../../ui/PlusButton';
import { heroFrames } from '../../../data/heroFrames';
import { useHeroLoop } from '../../../hooks/useHeroLoop';
import { useMediaQuery } from '../../../hooks/useMediaQuery';
const FRAME_DURATION = 4200;
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  const {
    index,
    setIndex,
    autoplay
  } = useHeroLoop(heroFrames.length, FRAME_DURATION);
  const isDesktop = useMediaQuery('(min-width: 1024px)');
  const frame = heroFrames[index];
  return <section aria-label="Présentation de l’atelier" className="relative bg-canvas pt-[72px]" data-id="element-151" data-mp="c9u5uwdt0mq7">
      <div className="relative h-[calc(100svh-144px)] min-h-[620px] overflow-hidden bg-night" data-id="element-152" data-mp="1inthe6zxb62e">
        <AnimatePresence initial={false} data-id="element-153" data-mp="1nlv0ut19h7ee">
          <motion.img key={frame.id} src={frame.src} alt={frame.alt} className="absolute inset-0 h-full w-full object-cover" initial={{
          opacity: 0,
          scale: 1.12
        }} animate={{
          opacity: 1,
          scale: 1.02
        }} exit={{
          opacity: 0
        }} transition={{
          opacity: {
            duration: 0.3,
            ease: 'easeOut'
          },
          scale: {
            duration: FRAME_DURATION / 1000 + 0.4,
            ease: 'linear'
          }
        }} data-id="element-154" data-mp="2rckk3msxi9yu" />
        </AnimatePresence>
        <div className="absolute inset-0 bg-night/35" data-id="element-155" data-mp="23mqade3wp1it" />
        <EmberCanvas intensity={frame.intensity} data-id="element-156" data-mp="23kvp1yoq37e7" />
        <PixelMask key={isDesktop ? 'desktop' : 'mobile'} variant={isDesktop ? 'desktop' : 'mobile'} data-id="element-157" data-mp="1yn3uewwp176b" />
        {isDesktop && <HeroHud frame={frame} index={index} total={heroFrames.length} data-id="element-158" data-mp="1unl9w28say40" />}

        <div className="shell relative flex h-full flex-col justify-between pb-10 pt-8 md:pt-14" data-id="element-159" data-mp="1pngtsdbsg5eb">
          <div data-id="element-160" data-mp="1knufs1o4yl4g">
            <motion.p initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            ease
          }} className="inline-flex bg-line px-3 py-1.5 text-sm text-ink" data-id="element-161" data-mp="1kpfbhum6sa3w">
              Bureau d’études & atelier de fabrication
            </motion.p>
            <motion.h1 initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            ease,
            delay: 0.08
          }} className="mt-6 text-[clamp(40px,5.2vw,84px)] font-medium leading-[0.95] tracking-[-0.04em] text-ink" data-id="element-162" data-mp="114f5ns0um4k1">
              <span className="block" data-id="element-163" data-mp="1yrxcuyev2ylx">Décors & volumes,</span>
              <span className="block" data-id="element-164" data-mp="1k0f0dal7nm7b">fabriqués en grand.</span>
            </motion.h1>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease,
          delay: 0.9
        }} className="max-w-xl text-white" data-id="element-165" data-mp="1oyovjl6xqmsx">
            <p className="text-base leading-relaxed text-white/85 md:text-lg" data-id="element-166" data-mp="2hinc8d5843a1">
              Robot 5 axes, usinage CNC, découpe plasma et projection de résine
              <span className="hidden sm:inline" data-id="element-167" data-mp="11gzqdsf42bn"> : un parc machines intégré pour donner corps aux décors de tournée, sculptures monumentales et scénographies lumineuses</span>.
            </p>
            <p className="mt-7 text-sm text-white/70" data-id="element-168" data-mp="atd0jwlw26jk">Un projet de décor ou de volume ?</p>
            <div className="mt-3" data-id="element-169" data-mp="3j7bxb0gopvy4">
              <PlusButton href="#contact" size="lg" data-id="element-170" data-mp="3j8dkg3az68w7">
                Contactez notre bureau d’études
              </PlusButton>
            </div>
          </motion.div>
        </div>
      </div>

      <HeroRuler frames={heroFrames} index={index} onSelect={setIndex} autoplay={autoplay} duration={FRAME_DURATION} data-id="element-171" data-mp="3sad0ote618y3" />
    </section>;
}